// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-cart-confirm[data-v-74ea3a6b]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
